<template>
    <div class="field">
        <label class="label">Auction Date</label>
        <div class="control">
            <input v-model="lotDate" class="input" type="date" placeholder="Select Date">
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            lotDate: {
                get: function () {
                    return this.$store.getters.getQueryLotDate
                },
                set: function (value) {
                    this.$store.dispatch('handleNewLotDate', value)
                }
            }
        }
    };
</script>

<style>
    input:focus {
        outline:none;
    }
    #tags{
        height: 100%;
    }
    .tags-input input{
        height: 100% !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Specification/DateInput.vue